import { render, staticRenderFns } from "./DetailEvent.vue?vue&type=template&id=a57101d6"
import script from "./DetailEvent.vue?vue&type=script&lang=js"
export * from "./DetailEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports